export default function ({
  _type,
  options,
  _key,
  ...props
}: Record<string, any>) {
  return {
    'data-module': _type,
    ...props,
  }
}
